// extracted by mini-css-extract-plugin
export default {"simpleLoader":"SimpleLoader_simpleLoader__XxjaZ","blink":"SimpleLoader_blink__BLzWk"};